export const ActivateLogs = window.ACTIVATE_LOGS;

